<template>
    <el-form :model="value" ref="formRef" label-position="top">
        <Panel title="连接池配置">
            <el-row>
                <el-col :span='12'>
                    <el-form-item class="flex-1" label="web服务地址" prop='wsdlurl'>
                        <el-input v-model="value.wsdlurl"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span='12'>
                    <el-form-item class="flex-1" label="用户名" prop='username'>
                        <el-input v-model="value.username"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span='12'>
                    <el-form-item class="flex-1" label="密码" prop='password'>
                        <el-input v-model="value.password"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </Panel>
        <Panel title="高级选项" collapse>
            <el-row>
                <el-col :span='12'>
                    <el-form-item class="flex-1" label="代理服务器地址" prop='proxyhost'>
                        <el-input v-model="value.proxyhost"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span='12'>
                    <el-form-item class="flex-1" label="代理服务器端口号" prop='proxyport'>
                        <el-input v-model="value.proxyport"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span='12'>
                    <el-form-item class="flex-1" label="代理服务器用户名" prop='proxyusername'>
                        <el-input v-model="value.proxyusername"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span='12'>
                    <el-form-item class="flex-1" label="代理服务器密码" prop='proxypassword'>
                        <el-input v-model="value.proxypassword"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span='12'>
                    <el-form-item class="flex-1" label="连接超时时间" prop='timeout'>
                        <el-input v-model="value.timeout"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </Panel>
    </el-form>
</template>
<script>
export default {
    // wsdlurl: "",
    // username: "",
    // password: "",
    // proxyhost: "",
    // proxyport: "",
    // proxyusername: "",
    // proxypassword: "",
    // timeout: "30"
    props: {
        value: Object,
        init: Boolean

    },
    mounted() {
        if (this.init) {
            this.$set(this.value, 'timeout', "30");
        }
    },
    methods: {
        validate() {
            return this.$refs.formRef.validate();
        }
    }
};
</script>

